import DashMetricTile from './DashMetricTile';
import type { AnalyticsDashMetric } from '../model';

interface DashMetricsProps {
    isUahMode: boolean;
    metrics: AnalyticsDashMetric[];
}

const DashMetrics = ({ isUahMode, metrics }: DashMetricsProps) => (
    <ul className="object-analytics-dash__grid list-unstyled mb-0">
        {metrics.map((metric) => (
            <DashMetricTile key={metric.key} isUahMode={isUahMode} metric={metric} />
        ))}
    </ul>
);

export default DashMetrics;
